export const isSafeInternalRedirect = redirect => {
  return typeof redirect === 'string'
    && redirect.startsWith('/')
    && !redirect.startsWith('//')
    && !/https?:\/\//i.test(redirect);
}
